import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Slot } from '../models/valueObjects/Slot';

export class SlotMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Slot {
    return new Slot(this.gqlIdEncoder.decode(data.id), data.name);
  }
}
